/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import moment from 'moment';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Button } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { Carousel, CarouselItem } from 'src/components/views/common/carousel';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { mixpanelV3Helper } from 'src/helpers/mixpanel-v3';
import * as dashboardActionV3 from 'actions/dashboard-v3-actions';
import aiCampaignBanner from 'src/assets/images/campaigns/ai-banner-campaign.png';

class CampaignCarousel extends Component<Props> {
  state = {
    triggerReRender: null
  };

  // Handle dismiss
  handleDismiss = () => {
    this.props.dismissDashboardBlock('marketingBanner');
  };

  render() {
    const { campaignBanners = [], enableAISearch } = this.props;

    if (!enableAISearch && !moment().startOf().isAfter(moment('2024-04-15 23:59:59'))) {
      campaignBanners.unshift({
        image: {
          source: aiCampaignBanner
        },
        url: routes.advancedSearch.view(),
        _id: 'ai-search-campaign-banner'
      });
    }
    if (campaignBanners.length <= 0) return null;

    const renderCampaignBanners = campaignBanners.map((banner, index) => (
      <li
        id={banner._id ? banner._id : `campaign-banner-${index}`}
        className="carousel-item"
        style={{
          background: `url("${banner.image.source}")`
        }}>
        <div onClick={() => this.handleOpenLink(banner.url)} className="banner"></div>
        <Button onClick={this.handleDismiss} icon={MobileCancelMajor} plain />
      </li>
    ));
    return (
      <div className={`BC-CampaignCarousel__DashboardV3`}>
        <Carousel
          autoDisplay={true}
          hideAction={true}
          items={renderCampaignBanners}
          renderItem={({ item, isSnapPoint, index }) => (
            <CarouselItem key={`element-${index}`} isSnapPoint={isSnapPoint}>
              {item}
            </CarouselItem>
          )}
        />
      </div>
    );
  }

  // Handle open link
  handleOpenLink = url => {
    if (_.startsWith(url, '/')) {
      history.push(url);
    } else window.open(url, '_blank');
    mixpanelV3Helper.trackEventData('Click Top Banner', { url });
  };
}

const mapStateToProps = (state, props) => ({
  tenantApp: _.get(state.oauth, 'tenantApp', {}),
  enableAISearch: _.get(
    state.oauth.tenantApp,
    'settings.instantSearch.settings.AI-synonyms',
    false
  ),
  campaignBanners: _.get(state.dashboardV3, 'campaignBanners', [])
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  dismissDashboardBlock: (blockName: string) =>
    dispatch(dashboardActionV3.processDismissBlock(blockName, ownProps.i18n))
});
export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(CampaignCarousel));
